import script from "./SharedButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedButton.vue?vue&type=script&setup=true&lang=ts"

import "./SharedButton.vue?vue&type=style&index=0&id=2df2fb74&lang=postcss"

const __exports__ = script;

export default __exports__